import { Table } from '@mantine/core';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

type LeadingHeader = {
  key: string;
  label: React.ReactNode;
  ta?: 'left' | 'right';
};

type SamplerCoverageMetricsHeadProps = {
  leadingHeaders: LeadingHeader[];
};

export const SamplerCoverageMetricsHead: FC<SamplerCoverageMetricsHeadProps> = ({
  leadingHeaders,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <Table.Tr>
        {leadingHeaders.map((header) => (
          <Table.Th key={header.key} rowSpan={2} ta={header.ta}>
            {header.label}
          </Table.Th>
        ))}
        <Table.Th colSpan={3} style={{ textAlign: 'center' }}>
          {t('surfacesMap.tables.pointsSection')}
        </Table.Th>
        <Table.Th colSpan={3} style={{ textAlign: 'center' }}>
          {t('surfacesMap.tables.analysesSection')}
        </Table.Th>
      </Table.Tr>
      <Table.Tr>
        <Table.Th ta="right">{t('surfacesMap.tables.carbonShort')}</Table.Th>
        <Table.Th ta="right">{t('surfacesMap.tables.granuloShort')}</Table.Th>
        <Table.Th ta="right">{t('surfacesMap.tables.totalShort')}</Table.Th>
        <Table.Th ta="right">{t('surfacesMap.tables.carbonShort')}</Table.Th>
        <Table.Th ta="right">{t('surfacesMap.tables.granuloShort')}</Table.Th>
        <Table.Th ta="right">{t('surfacesMap.tables.totalShort')}</Table.Th>
      </Table.Tr>
    </>
  );
};
